import React from 'react';
import { styled } from '@compiled/react';
import Avatar from '@atlaskit/avatar';
import { token } from '@atlaskit/tokens';
import type { UserShare } from '@atlassian/jira-shared-types';

import userAvatar from './assets/useravatar.svg';

type Props = {
	sharePermission: UserShare;
};

const UserName = (props: Props) => {
	const {
		sharePermission: { user },
	} = props;

	const icon = user.avatarUrl || userAvatar;

	return (
		<>
			<AvatarWrapper>
				<Avatar appearance="square" src={icon} size="small" />
			</AvatarWrapper>
			<UserNameContainer>
				<UserNameWrapper>{user.displayName}</UserNameWrapper>
			</UserNameContainer>
		</>
	);
};

export default UserName;

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const UserNameContainer = styled.div({
	display: 'flex',
	alignItems: 'center',
	minWidth: 0,
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const RoleNameWrapper = styled.div({
	whiteSpace: 'nowrap',
	textOverflow: 'ellipsis',
	overflow: 'hidden',
	minWidth: 0,
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const UserNameWrapper = styled(RoleNameWrapper)({
	marginLeft: token('space.100', '8px'),
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const AvatarWrapper = styled.div({
	flex: '0 0 auto',
});
